// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container for the pagination (ul element) */
.pagination {
    display: flex;
    list-style: none;
    padding: 0;
    justify-content: center;
    margin-top: 20px; /* Adjust as needed */
  }
  
  /* Each page item (li element) */
  .pagination li {
    margin: 0 4px;
  }
  
  /* Style for the links inside each page item */
  .pagination li a {
    border: 1px solid #ccc;
    padding: 6px 12px;
    border-radius: 4px;
    cursor: pointer;
    color: #333;
    text-decoration: none;
    transition: background-color 0.3s, border-color 0.3s;
  
    /* This line shifts the buttons down a bit */
    position: relative;
    top: 2px; /* Increase or decrease as desired */
  }
  
  /* Hover state for page links */
  .pagination li a:hover {
    background-color: #f0f0f0;
    border-color: #999;
  }
  
  /* Style for the active page item */
  .pagination li.active a {
    background-color: #3182ce;
    color: #fff;
    border-color: #3182ce;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/screen/css/paginate.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;IACI,aAAa;IACb,gBAAgB;IAChB,UAAU;IACV,uBAAuB;IACvB,gBAAgB,EAAE,qBAAqB;EACzC;;EAEA,gCAAgC;EAChC;IACE,aAAa;EACf;;EAEA,8CAA8C;EAC9C;IACE,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,qBAAqB;IACrB,oDAAoD;;IAEpD,4CAA4C;IAC5C,kBAAkB;IAClB,QAAQ,EAAE,oCAAoC;EAChD;;EAEA,+BAA+B;EAC/B;IACE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA,mCAAmC;EACnC;IACE,yBAAyB;IACzB,WAAW;IACX,qBAAqB;EACvB","sourcesContent":["/* Container for the pagination (ul element) */\n.pagination {\n    display: flex;\n    list-style: none;\n    padding: 0;\n    justify-content: center;\n    margin-top: 20px; /* Adjust as needed */\n  }\n  \n  /* Each page item (li element) */\n  .pagination li {\n    margin: 0 4px;\n  }\n  \n  /* Style for the links inside each page item */\n  .pagination li a {\n    border: 1px solid #ccc;\n    padding: 6px 12px;\n    border-radius: 4px;\n    cursor: pointer;\n    color: #333;\n    text-decoration: none;\n    transition: background-color 0.3s, border-color 0.3s;\n  \n    /* This line shifts the buttons down a bit */\n    position: relative;\n    top: 2px; /* Increase or decrease as desired */\n  }\n  \n  /* Hover state for page links */\n  .pagination li a:hover {\n    background-color: #f0f0f0;\n    border-color: #999;\n  }\n  \n  /* Style for the active page item */\n  .pagination li.active a {\n    background-color: #3182ce;\n    color: #fff;\n    border-color: #3182ce;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
